import { NotificationType } from "@features/notifications/NotificationToasts/utlis/types";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type NotificationStore = {
  /** Notification Object - includes icon, text, link, type */
  notification: NotificationType;
  /** Indication of Loading state of the notification */
  isNotificationLoading: boolean;
  /** Indication of Display state of the notification */
  isNotificationDisplayed: boolean;
  /** Function to set the notification */
  setNotification: (notification: NotificationType) => void;
  /** Function to set the loading state of the notification */
  setIsNotificationLoading: (isLoading: boolean) => void;
  /** Function to set the display state of the notification */
  setIsNotificationDisplayed: (isLoading: boolean) => void;
};

/**
 * This store persists its state to `localStorage` under the key `"bt-notification"`.
 * It provides state and actions for handling notification objects - text, icon, link , their loading state,
 * and display state.
 */
const useNotificationStore = create(
  persist<NotificationStore>(
    (set) => ({
      isNotificationLoading: false,
      isNotificationDisplayed: false,
      notification: {
        text: "",
        link: "",
      },
      setNotification: (notification: NotificationType) => {
        set(() => ({ notification }));
      },
      setIsNotificationLoading: (isNotificationLoading: boolean) => {
        set(() => ({ isNotificationLoading }));
      },
      setIsNotificationDisplayed: (isNotificationDisplayed: boolean) => {
        set(() => ({ isNotificationDisplayed }));
      },
    }),
    {
      name: "bt-notification", // unique name
      storage: createJSONStorage(() => localStorage), // Specify localStorage as the storage option
    }
  )
);

export default useNotificationStore;
